export const CHECKOUT_INACTIVE_OFFER = 'checkout.offer_inactive';
export const CHECKOUT_PRODUCT_IS_OUT_OF_STOCK = 'checkout.product_is_out_of_stock';

export const CHECKOUT_OFFER_IS_NOT_DELIVERABLE = 'CART.OFFER_LINE.VALIDATION.REGION_NOT_AVAILABLE';
